"use client";

import Modal from "@/components/ui/modal";
import EditorMediaUpload from "./editor-media-upload";
import { TPostMedia } from "@/types/post";

const EditorMediaUploadModal = ({
	isOpen,
	onClose,
	onImagesSelected,
}: {
	isOpen: boolean;
	onClose: () => void;
	onImagesSelected: (images: Omit<TPostMedia, "id">[]) => void;
}) => {
	return (
		<Modal title="Add Media" isOpen={isOpen} onClose={onClose} className="max-w-3xl">
			<EditorMediaUpload onImagesSelected={onImagesSelected} onClose={onClose} />
		</Modal>
	);
};

export default EditorMediaUploadModal;
